import { motion } from "framer-motion";

export const Em = props => {
	return (
		<motion.em variants={emAnimation} {...props}>
			{props.children}
		</motion.em>
	);
};

const emAnimation = {
	initial: { backgroundPosition: "0%" },
	whileInView: { backgroundPosition: "80%", transition: { duration: 0.7 } },
};
